/**
 * Convert a CSS color to a 32bit integer.
 * Uses a 1x1 canvas to convert the colour.
 * Supports any valid CSS color.
 */
const convertColor = {

	/**
	 * Canvas context.
	 */
	ctx: null,


	/**
	 * Create the canvas context.
	 *
	 * @return {void}
	 */
	init: function() {

		if ( convertColor.ctx ) {
			return;
		}

		convertColor.ctx = document.createElement( 'canvas' ).getContext( '2d' );
		convertColor.ctx.canvas.width = 1;
		convertColor.ctx.canvas.height = 1;

	},


	/**
	 * Convert the CSS color to a 32bit integer.
	 *
	 * @param {string} cssColor The css color to convert. Can be any valid CSS color.
	 * @return {number}
	 */
	run: function( cssColor ) {

		convertColor.init();

		convertColor.ctx.clearRect( 0, 0, 1, 1 );
		convertColor.ctx.fillStyle = cssColor;
		convertColor.ctx.fillRect( 0, 0, 1, 1 );

		const imgData = convertColor.ctx.getImageData( 0, 0, 1, 1 );

		return new Uint32Array( imgData.data.buffer )[ 0 ];

	}

};
